<div
    class="st-cast-item"
    [class.st-cast-item__mouse-entered]="mouseEntered"
    [class.st-cast-item-disabled]="isReadOnly"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">
    <ng-container [ngSwitch]="viewStateLayoutValue$ | ngrxPush">
        <ng-template [ngSwitchCase]="viewStateLayouts.CONDENSE">
            <ng-container [ngSwitch]="publication?.linkedRecords?.[0]?.Type">
                <ng-template [ngSwitchCase]="ObjectTypesEnum.ASSIGNMENT">
                    <st-assignment-condensed
                        class="st-cast-item-assignment-condensed"
                        [isReadOnly]="isReadOnly"
                        [data]="linkedAssignment"
                        [isPublication]="true"
                        [class.st-cast-item-assignment-condensed-last]="lastInGroup"
                        [class.st-cast-item-assignment-condensed-first]="firstInGroup"
                        (assignmentOpenEmitter)="onFullscreenHandler(linkedAssignment)"
                        (deletePublicationEmitter)="deletePublication(publication)" />
                </ng-template>
                <ng-template ngSwitchDefault>
                    <st-topic-item-condensed
                        class="st-cast-item-topic-condensed"
                        [data]="linkedTopic"
                        [isPublication]="true"
                        [isReadOnly]="isReadOnly"
                        [class.st-cast-item-topic-condensed-last]="lastInGroup"
                        [class.st-cast-item-topic-condensed-first]="firstInGroup"
                        (topicItemClicked)="onFullscreenHandler(linkedTopic)"
                        (assignmentOpenEmitter)="onFullscreenHandler(linkedAssignment)"
                        (deletePublicationEmitter)="deletePublication(publication)" />
                </ng-template>
            </ng-container>
        </ng-template>
        <ng-template ngSwitchDefault>
            <ng-container [ngSwitch]="publication?.linkedRecords?.[0]?.Type">
                <ng-template [ngSwitchCase]="ObjectTypesEnum.ASSIGNMENT">
                    <st-assignment-item
                        [data]="linkedAssignment"
                        [dragEnabled]="false"
                        [isPublication]="true"
                        [isReadOnly]="isReadOnly"
                        (assignmentOpenEmitter)="onFullscreenHandler(linkedAssignment)"
                        (deletePublicationEmitter)="deletePublication(publication)" />
                </ng-template>
                <ng-template ngSwitchDefault>
                    <st-topic-item
                        [data]="linkedTopic"
                        [isReadOnly]="isReadOnly"
                        [class.st-cast-item-topic-last]="lastInGroup"
                        [class.has-dynamic-controls]="shouldShowCustomFields"
                        [dragEnabled]="false"
                        [isPublication]="true"
                        (topicItemClicked)="onFullscreenHandler(linkedTopic)"
                        (deletePublicationEmitter)="deletePublication(publication)" />
                </ng-template>
            </ng-container>
        </ng-template>
        <!-- <button mat-icon-button
            (click)="removePublication($event, publication)">
        <mat-icon>delete_outline</mat-icon>
    </button> -->
    </ng-container>
</div>
